// Build the API payload for creating/updating an admin-managed user account.
// Centralises the multi-tenant company scoping so users.vue stays lean:
// - admin picks the company explicitly (normalised to a numeric id or null);
// - miniadmin is forced to their own company from the auth token;
// - any other role never sends a company at all.
// On edit, an empty password is dropped so it is not overwritten.
export function buildUserPayload(record, { isAdmin, isMiniAdmin, userCompanyId, isEdit }) {
  const payload = { ...record };

  if (isEdit && !payload.password) {
    delete payload.password;
  }

  if (isAdmin) {
    if (payload.company_id && typeof payload.company_id === "object") {
      payload.company_id = payload.company_id.id;
    }
    if (payload.company_id === "" || payload.company_id === undefined) {
      payload.company_id = null;
    }
    if (payload.company_id !== null) {
      payload.company_id = Number(payload.company_id);
      payload.companyId = payload.company_id;
    }
  } else if (isMiniAdmin && userCompanyId !== null) {
    payload.company_id = userCompanyId;
    payload.companyId = userCompanyId;
  } else {
    delete payload.company_id;
    delete payload.companyId;
  }

  return payload;
}
